// FullScreenNav.js
import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { Link, useLocation } from "react-router-dom";
import { XMarkIcon } from "@heroicons/react/24/outline";

const FullScreenNav = ({ isVisible, closeNav }) => {
    const location = useLocation();
    const { user, logout } = useAuth();

    return (
        <div
            className={`fixed inset-0 bg-background z-50 transition-transform transform ${
                isVisible ? "translate-x-0" : "translate-x-full"
            }`}
        >
            {/* Close Button */}
            <button
                onClick={closeNav}
                className="absolute top-5 right-5 bg-transparent border-none cursor-pointer z-50"
                aria-label="Close navigation"
            >
                <XMarkIcon className="h-8 w-8 text-secondary" />
            </button>

            {/* Navigation Items */}
            <nav className="flex flex-col items-center justify-center h-full space-y-6">
                {!user && (
                    <Link
                        to="/try"
                        state={{ from: location.pathname }}
                        onClick={closeNav}
                        className="bg-accent hover:bg-accentDark text-white font-semibold py-3 px-8 rounded-full transition-colors text-lg"
                    >
                        Try a full session
                    </Link>
                )}
                
                <ul className="text-center space-y-4">
                    <li className="text-2xl">
                        <Link to="/" onClick={closeNav} className="text-secondary hover:text-accent transition-colors">
                            Home
                        </Link>
                    </li>
                    
                    {/* Learn Section */}
                    <li className="pt-4 border-t border-tint">
                        <span className="text-sm text-textSecondary uppercase tracking-wide">Learn</span>
                    </li>
                    <li className="text-xl">
                        <Link to="/demo" onClick={closeNav} className="text-secondary hover:text-accent transition-colors">
                            Watch the demo
                        </Link>
                    </li>
                    <li className="text-xl">
                        <Link to="/what-is-bilateral-stimulation" onClick={closeNav} className="text-secondary hover:text-accent transition-colors">
                            What is Bilateral Stimulation?
                        </Link>
                    </li>
                    <li className="text-xl">
                        <Link to="/how-it-works" onClick={closeNav} className="text-secondary hover:text-accent transition-colors">
                            The Science
                        </Link>
                    </li>
                    <li className="text-xl">
                        <Link to="/about" onClick={closeNav} className="text-secondary hover:text-accent transition-colors">
                            About Us
                        </Link>
                    </li>
                    <li className="text-xl">
                        <a
                            href="https://blog.realignmind.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-secondary hover:text-accent transition-colors"
                            onClick={closeNav}
                        >
                            Blog
                        </a>
                    </li>
                    
                    {!user && (
                        <>
                            <li className="pt-4 border-t border-tint">
                                <Link to="/login" state={{ mode: "register" }} onClick={closeNav} className="text-accent hover:underline font-semibold text-xl transition-colors">
                                    Sign up free
                                </Link>
                            </li>
                            <li className="text-lg">
                                <Link to="/login" onClick={closeNav} className="text-textSecondary hover:text-accent transition-colors">
                                    Login
                                </Link>
                            </li>
                        </>
                    )}
                    {user && (
                        <>
                            <li className="pt-4 border-t border-tint text-2xl">
                                <Link to="/sessions" onClick={closeNav} className="text-accent hover:underline font-semibold transition-colors">
                                    Start Session
                                </Link>
                            </li>
                            <li className="text-xl">
                                <Link to="/profile" onClick={closeNav} className="text-secondary hover:text-accent transition-colors">
                                    Profile
                                </Link>
                            </li>
                            <li className="text-xl">
                                <Link to="/session-history" onClick={closeNav} className="text-secondary hover:text-accent transition-colors">
                                    Session History
                                </Link>
                            </li>
                            <li className="text-lg pt-4">
                                <button
                                    onClick={() => {
                                        logout();
                                        closeNav();
                                    }}
                                    className="text-textSecondary hover:text-accent transition-colors"
                                >
                                    Logout
                                </button>
                            </li>
                        </>
                    )}
                </ul>
            </nav>
        </div>
    );
};

export default FullScreenNav;
